<script setup lang="ts">
import UiSelector from '@@/lib/ui-toolkit/components/UiSelector.vue';
import MenuIcon from '@/icons/burger.svg?skipsvgo';

const active = defineModel<boolean>('active');
</script>

<template>
  <UiSelector
    v-model="active"
    label="Menu"
    class="menu-button"
    unstyled
  >
    <MenuIcon class="menu-icon" />
  </UiSelector>
</template>

<style lang="scss" scoped>
.menu-button {
  height: 2rem;
  line-height: 1rem;
  border-radius: 0.2rem;
  transition: color var(--anim-speed) ease;

  &:hover {
    color: var(--colour-mid-grey);
  }
  &:focus-visible {
    outline: 2px solid var(--colour-warm-grey);
  }
}
:deep(.menu-icon) {
  height: 2rem;

  circle {
    opacity: 1;
    transition: opacity var(--anim-speed) ease;
  }
  line {
    transition: all var(--anim-speed) ease;
    transform-origin: center;
    transform: scale(0);
  }

  [data-state="on"] & {
    circle.hider {
      opacity: 0;
    }
    line {
      transform: scale(1);
    }
  }
}
</style>
